import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HotList from './HotList';
import PublishCard from './PublishCard';
import NotificationList from '../notification/NotificationList';
import { useRightPanel } from '../../contexts/RightPanelContext';
import friendService from '../../services/friendService';

const RightSidePanel = ({ onItemClick, variant = 'fixed' }) => {
  const { activePanel } = useRightPanel();
  const navigate = useNavigate();
  const [hotList, setHotList] = useState([]);

  const fetchHotList = useCallback(async () => {
    try {
      const hotListRes = await friendService.searchContents({
        type: 'article',
        filter: {
          exprs: [{ field: 'status', op: 'EQ', values: ['published'] }],
        },
        sort: { field: 'hot', desc: true },
        pagination: { page: 1, per_page: 10 },
      });

      setHotList(
        (hotListRes?.contents || []).map((item) => ({
          id: item.id,
          title: item.fields?.title || 'Untitled',
          hotValue: item.hot_score ? Math.round(item.hot_score) : 0,
          tag: '热',
          category: item.fields?.category || item.category,
        }))
      );
    } catch (error) {
      setHotList([]);
    }
  }, []);

  useEffect(() => {
    fetchHotList();
  }, [fetchHotList]);

  const handleHotItemClick = useCallback(
    (item) => {
      if (onItemClick) {
        onItemClick(item);
        return;
      }

      if (item.category === 'competition') {
        navigate(`/explore/proposals/${item.id}`);
        return;
      }
      navigate(`/explore/friends/${item.id}`);
    },
    [navigate, onItemClick]
  );

  const renderContent = () => {
    switch (activePanel) {
      case 'publish':
        return <PublishCard />;
      case 'notification':
        return <NotificationList />;
      case 'hot':
      default:
        return <HotList items={hotList} onItemClick={handleHotItemClick} />;
    }
  };

  if (variant === 'drawer') {
    return <div className="w-[328px] h-[732px] flex flex-col mx-auto">{renderContent()}</div>;
  }

  if (variant === 'viewport') {
    return (
      <div className="w-[328px] h-[732px] fixed right-[36px] top-[96px] flex flex-col z-40">
        {renderContent()}
      </div>
    );
  }

  return <div className="w-[328px] h-[732px] sticky top-[96px] flex flex-col">{renderContent()}</div>;
};

export default RightSidePanel;
